import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setAvailableFilters } from '../redux/filtersReducer';
import useGetVehicles from './useGetVehicles';
import { selectVehicles, setVehicles } from '../redux/vehicleListReducer';
import { resultsReturnedFailed } from '../utils/analyticsEventListeners';

const useFilteredVehicles = () => {
  const dispatch = useDispatch();

  // Running fetch hook to grab vehicles list
  const { loading, fetchMore, error, data } = useGetVehicles();

  // After getting vehicles - uploading them to redux
  useEffect(() => {
    if (!data) return;
    const { vehicles, filterResults, rangeResults } = data.getFilteredVehiclesForWormwood;
    dispatch(setAvailableFilters({ filterResults, rangeResults }));
    dispatch(
      setVehicles({
        vehiclesList: vehicles,
        totalCount: filterResults.totalCount,
      }),
    );
  }, [data, dispatch]);

  useEffect(() => {
    if (error) {
      const errorCode = error?.graphQLErrors[0]?.extensions?.code ?? null;
      resultsReturnedFailed({
        errorMessage: error?.message,
        errorCode,
      });
    }
  }, [error]);

  // Getting data from Redux
  const { vehiclesList, totalCount } = useSelector(selectVehicles);

  return { vehiclesList, loading, totalCount, fetchMore };
};

export default useFilteredVehicles;
